import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { DatevRechercheGroup } from 'src/modules/enaio/shared/DatevRechercheGroup';
import { DatevRechercheType } from 'src/modules/enaio/shared/DatevRechercheType';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableCell } from 'src/modules/sm-base/models/table-cell.model';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { DhTools } from '../../models/dh-tools.model';
import { TableCellButton } from 'src/modules/sm-base/models/table-cell-button.model';
import { TableCellEvent } from 'src/modules/sm-base/models/table-cell-event.model';

@Component({
    selector: 'app-datev-invoice-summary',
    templateUrl: './datev-invoice-summary.component.html',
    styleUrls: ['./datev-invoice-summary.component.scss']
  })
  export class DatevInvoiceSummaryComponent extends ComponentView {

    _Utils = Utils;

    form: FrontendFormDefinition;
    result: DatevRechercheGroup[];
    table: TableData;
    source = "enaio";

    async initParams(): Promise<boolean> {
        this.form = new FrontendFormDefinition([
            new FrontendFieldDefinition("fromDate", "Startdatum", FrontendFieldType.datePicker, { value: Utils.dateStartOf(new Date(), "year") })
        ]);
        return Promise.resolve(true);
    }

    async get(): Promise<void> {
        this.result = await DhTools.backendCall("api/datev/rechercheAll", { fromDate: this.form.getValue("fromDate")}).list(DatevRechercheGroup);
        this.updateTable();
    }

    updateTable(): void {
        this.table = new TableData([
            new TableColumn("action", "", TableCellType.button, { autoWidth: 1 }),
            new TableColumn("documentNumber", "Rechnungsnummer", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("amount", "Betrag", TableCellType.decimal, { autoWidth: 8}),
            new TableColumn("date", "Datum", TableCellType.dateTime, { autoWidth: 1}),
            new TableColumn("workflowIds", "Workflow IDs", TableCellType.text, { autoWidth: 1}),
            new TableColumn("numEnaioObjects", "enaio Objekte", TableCellType.int),
            new TableColumn("numEnaioWorkflows", "enaio Workflows", TableCellType.int),
            new TableColumn("numDatev", "datev", TableCellType.int),
            new TableColumn("numDhLog", "DH Log", TableCellType.int),
            new TableColumn("numDhDone", "DH Done", TableCellType.int),
            new TableColumn("numDhError", "DH Error", TableCellType.int)
        ], Utils.arrayWithoutNull(this.result.map(g => {
            let numEnaioObjects = g.items.filter(item => item.type == DatevRechercheType.enaioObject).length;
            let numEnaioWorkflows = g.items.filter(item => item.type == DatevRechercheType.enaioWorkflow).length;
            let numDatev = g.items.filter(item => item.type == DatevRechercheType.datev).length;
            let numDhLog = g.items.filter(item => item.type == DatevRechercheType.dhLog).length;
            let numDhDone = g.items.filter(item => item.type == DatevRechercheType.dhDone).length;
            let numDhError = g.items.filter(item => item.type == DatevRechercheType.dhError).length;
            if (this.source == "enaio" && numEnaioObjects == 0 && numEnaioWorkflows == 0 || this.source == "datev" && numDatev == 0) {
                return null;
            }
            return new TableRow("", g, {
                action: [new TableCellButton("openEnaioObject", "fas fa-cog", "enaio Objekt öffnen")],
                documentNumber: g.documentNumber,
                amount: g.amount, 
                date: Utils.arrayGetSafe(g.items, 0)?.invoiceDate,
                workflowIds: Utils.arrayItemsToString(g.items.filter(item => item.type == DatevRechercheType.enaioWorkflow && !Utils.isNoe(item.enaioWorkflowId)), ", ", item => item.enaioWorkflowId),
                numEnaioObjects: new TableCell(numEnaioObjects, { styleClass: this.source != "enaio" && numEnaioObjects == 0 ? "xbg-red-400" : "" }),
                numEnaioWorkflows: new TableCell(numEnaioWorkflows, { styleClass: numEnaioWorkflows == 0 ? "xbg-red-400" : "" }),
                numDatev: new TableCell(numDatev, { styleClass: this.source != "datev" && numDatev == 0 ? "xbg-red-400" : "" }),
                numDhLog: new TableCell(numDhLog, { styleClass: numDhLog == 0 ? "xbg-red-400" : "" }),
                numDhDone: new TableCell(numDhDone, { styleClass: numDhDone + numDhError == 0 ? "xbg-red-400" : "" }),
                numDhError: new TableCell(numDhError, { styleClass: numDhDone + numDhError == 0 ? "xbg-red-400" : "" })
            });
    })), [new TableSortColumn("documentNumber"), new TableSortColumn("amount")]);

    }

    async clickCell(event: TableCellEvent): Promise<void> {
        if (event.isButton("openEnaioObject", "action")) {
            let item = (event.row.raw as DatevRechercheGroup).items.filter(item2 => item2.type == DatevRechercheType.enaioObject);
            if (!Utils.isNoe(item)) {
                await DhTools.backendCall("api/enaio/openDocument", { id: item[0].id }).getText();
            }
        }
    }
}
